import { React, useEffect } from "react";
import { Skeleton } from "@mui/material";
import TaskAccessComponent from "../../../../components/tasks/TaskAccessComponent";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { USER_ROLES } from "constants";
import SuccessModal from "components/modals/SuccessModal";
import { useState } from "react";
import { enviornmentRestrict, sendAPIRequest } from "helpers";
import NewFeaturePopUpModal from "components/modals/NewFeaturePopUpModal";

const TaskCard = ({ requestRelloader, handleClickScroll }) => {

  const authData = useSelector((s) => s.auth.data);
  const { t } = useTranslation();
  const [showModal, setShowModel] = useState(false);
  const [showNewFeature, setShowNewFeature] = useState(false);
  const [userMissionStatus, setUserMissionStatus] = useState(null);
  const [loadingUserMissionStatus, setLoadingUserMissionStatus] = useState(true);

  const loadUserMissionStatus = async (userId) => {
    try {
      setLoadingUserMissionStatus(true);
      const req = await sendAPIRequest(`/api/auth/user-mission-status/${userId}`);
      const res = await req.json();
      if (res.success && res.data) {
        setUserMissionStatus(res.data)
      } else {
        setUserMissionStatus(null)
      }
      setLoadingUserMissionStatus(false);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (authData?.id) {
      loadUserMissionStatus(authData.id);
    }
  }, [authData]);

  return (
    <>
      {showModal && (
        <SuccessModal
          reloadData={(params) => setShowModel(false)}
          children={(handleOpen) => handleOpen()}
          header={t("3283", "FEATURE COMING SOON")}
          title={t("3284", "New features will be rolled out to the PVS IS as development continues. Thank you for yor patience as we make new features and tools available to our users!")}
          navigationLink={"/portal"}
        />
      )}
      <NewFeaturePopUpModal showModal={showNewFeature} handleClose={() => setShowNewFeature(prev => !prev)} />
      <div className="container my-1">
        <div className="card card-woah border border-secondary mb-2 shadow rounded-0">
          <div className="card-body p-4">
            <div className="row justify-content-start">
              {USER_ROLES.business_admin.includes(parseInt(authData.role_id))
                && (
                  <>
                    <div className="row">
                      <div className="pt-3 px-4">
                        <i class="fa-solid fa-star text-primary me-2 "></i>
                        <span
                          className="pvs-title fw-bold fs-2 lh-1"
                        >
                          {t("-1", "Missions")}
                        </span>
                      </div>
                      <div className="col-md-4 col-sm-6 col-12">
                        <Link
                          // onClick={(e) => {
                          //   if (enviornmentRestrict("PROD")) {
                          //     e.preventDefault();
                          //     setShowNewFeature(true);
                          //   }
                          // }}
                          to="/portal/mission-cc"
                          className="d-block text-center btn-menu-dark-orange-left text-white my-2 fw-bold corner-rounded py-10 px-10 w-100 shadow-sm"
                        >
                          <span className="text-uppercase">{t("-1", "Mission Control Center").toUpperCase()}</span>
                        </Link>
                      </div>
                    </div>
                    <div className={`row ${enviornmentRestrict("PROD") ? "d-none" : ""}`}>
                      <div className="pt-3 px-4">
                        <i class="fa-solid fa-star text-primary me-2 "></i>
                        <span
                          className="pvs-title fw-bold fs-2 lh-1"
                        >
                          {t("-1", "Surveys")}
                        </span>
                      </div>
                      <div className="col-md-4 col-sm-6 col-12">
                        <Link
                          to="/portal/survey-cc"
                          className="d-block text-center btn-menu-dark-green-left text-white my-2 fw-bold corner-rounded py-10 px-10 w-100 shadow-sm"
                        >
                          <span className="text-uppercase">{t("-1", "Impact Assessment Survey").toUpperCase()}</span>
                        </Link>
                      </div>
                      <div className="col-md-4 col-sm-6 col-12">
                        <Link
                          onClick={() => setShowModel(true)}
                          className="d-block text-center btn-menu-light-green-left btn-menu-dark-green-color my-2 fw-bold corner-rounded py-10 px-10 w-100 shadow-sm"
                        >
                          <span className="text-uppercase">
                            {t("-1", "Learning Need Assessment Survey").toUpperCase()}
                          </span>
                        </Link>
                      </div>
                    </div>
                    {/* {showModal && (
                      <SuccessModal
                        reloadData={(params) => setShowModel(false)}
                        children={(handleOpen) => handleOpen()}
                        header={t("3283", "FEATURE COMING SOON")}
                        title={t("3284", "New features will be rolled out to the PVS IS as development continues. Thank you for yor patience as we make new features and tools available to our users!")}
                        navigationLink={"/portal"}
                      />
                    )} */}
                    <div className="row">
                      <div className="pt-3 px-4">
                        <i class="fa-solid fa-star text-primary me-2 "></i>
                        <span
                          className="pvs-title fw-bold fs-2 lh-1"
                        >
                          {t("-1", "Reports and Documents")}
                        </span>
                      </div>
                      <div className="col-md-4 col-sm-6 col-12">
                        <Link
                          to="/portal/document-management/?return=/portal"
                          className="d-block text-center btn-menu-dark-blue-left text-white my-2 fw-bold corner-rounded py-10 px-10 w-100 shadow-sm"
                        >
                          <span className="text-uppercase">{t("951", "MANAGE REPORTS").toUpperCase()}</span>
                        </Link>
                      </div>
                      <div className="col-md-4 col-sm-6 col-12">
                        <Link
                          to="/portal/document-management/create/?return=/portal"
                          className="d-block text-center btn-menu-light-blue-left btn-menu-dark-blue-color my-2 fw-bold corner-rounded py-10 px-10 w-100 shadow-sm"
                        >
                          <span className="text-uppercase">{t("622", "UPLOAD DOCUMENTS").toUpperCase()}</span>
                        </Link>
                      </div>
                    </div>
                    <div className="row">
                      <div className="pt-3 px-4">
                        <i class="fa-solid fa-star text-primary me-2 "></i>
                        <span
                          className="pvs-title fw-bold fs-2 lh-1"
                        >
                          {t("-1", "Experts and Partners")}
                        </span>
                      </div>
                      <div className="col-md-4 col-sm-6 col-12">
                        <Link
                          to="/portal/experts-management/?return=/portal"
                          className="d-block text-center btn-menu-dark-green-left text-white my-2  fw-bold corner-rounded py-10 px-10 w-100 shadow-sm"
                        >
                          <span className="text-uppercase">{t("949", "MANAGE EXPERTS").toUpperCase()}</span>
                        </Link>
                      </div>
                      <div className="col-md-4 col-sm-6 col-12">
                        <Link
                          to="/portal/partner-tech/index"
                          className="d-block text-center btn-menu-medium-green-left btn-menu-dark-green-color my-2 fw-bold corner-rounded py-10 px-10 w-100 shadow-sm"
                        >
                          <span className="text-uppercase">{t("-1", "MANAGE Technical Partners").toUpperCase()}</span>
                        </Link>
                      </div>
                    </div>
                    <div className="row">
                      <div className="pt-3 px-4">
                        <i class="fa-solid fa-star text-primary me-2 "></i>
                        <span
                          className="pvs-title fw-bold fs-2 lh-1"
                        >
                          {t("-1", "MetaData")}
                        </span>
                      </div>
                      <div className="col-md-4 col-sm-6 col-12">
                        <Link
                          to="/portal/metadata-management/?return=/portal"
                          className="d-block text-center btn-menu-light-black-left my-2 btn-menu-dark-black-color fw-bold corner-rounded py-10 px-10 w-100 shadow-sm"
                        >
                          <span className="text-uppercase">{t("950", "MANAGE METADATA").toUpperCase()}</span>
                        </Link>
                      </div>
                    </div>
                  </>
                )}

              {
                USER_ROLES.cbd_staff.includes(parseInt(authData.role_id)) && (
                  <>
                    <div className="row">
                      <div className="pt-3 px-4">
                        <i class="fa-solid fa-star text-primary me-2 "></i>
                        <span
                          className="pvs-title fw-bold fs-2 lh-1"
                        >
                          {t("-1", "Missions")}
                        </span>
                      </div>
                      <div className="col-md-4 col-sm-6 col-12">
                        <Link
                          to="/portal/mission-cc"
                          className="d-block text-center btn-menu-dark-orange-left text-white my-2 fw-bold corner-rounded py-10 px-10 w-100 shadow-sm"
                        >
                          <span className="text-uppercase">{t("-1", "Mission Control Center").toUpperCase()}</span>
                        </Link>
                      </div>
                    </div>
                    <div className="row">
                      <div className="pt-3 px-4">
                        <i class="fa-solid fa-star text-primary me-2 "></i>
                        <span
                          className="pvs-title fw-bold fs-2 lh-1"
                        >
                          {t("-1", "Reports and Documents")}
                        </span>
                      </div>
                      <div className="col-md-4 col-sm-6 col-12">
                        <Link
                          to="/portal/document-management/?return=/portal"
                          className="d-block text-center btn-menu-dark-blue-left text-white my-2 fw-bold corner-rounded py-10 px-10 w-100 shadow-sm"
                        >
                          <span className="text-uppercase">{t("951", "MANAGE REPORTS").toUpperCase()}</span>
                        </Link>
                      </div>
                      <div className="col-md-4 col-sm-6 col-12">
                        <Link
                          to="/portal/document-management/create/?return=/portal"
                          className="d-block text-center btn-menu-light-blue-left btn-menu-dark-blue-color my-2 fw-bold corner-rounded py-10 px-10 w-100 shadow-sm"
                        >
                          <span className="text-uppercase">{t("622", "UPLOAD DOCUMENTS").toUpperCase()}</span>
                        </Link>
                      </div>
                    </div>
                    <div className="row">
                      <div className="pt-3 px-4">
                        <i class="fa-solid fa-star text-primary me-2 "></i>
                        <span
                          className="pvs-title fw-bold fs-2 lh-1"
                        >
                          {t("-1", "Experts")}
                        </span>
                      </div>
                      <div className="col-md-4 col-sm-6 col-12">
                        <Link
                          to="/portal/experts-management/?return=/portal"
                          className="d-block text-center btn-menu-dark-green-left text-white my-2 fw-bold corner-rounded py-10 px-10 w-100 shadow-sm"
                        >
                          <span className="text-uppercase">{t("949", "MANAGE EXPERTS").toUpperCase()}</span>
                        </Link>
                      </div>
                    </div>
                  </>
                )}
              {USER_ROLES.focal_point.includes(parseInt(authData.role_id)) && (
                <>
                  <div className="row">
                    <div className="pt-3 px-4">
                      <i class="fa-solid fa-star text-primary me-2 "></i>
                      <span
                        className="pvs-title fw-bold fs-2 lh-1"
                      >
                        {t("-1", "Reports and Documents")}
                      </span>
                    </div>
                    <div className="col-md-4 col-sm-6 col-12">
                      <Link
                        to="/portal/documents"
                        className="d-block text-center btn-menu-dark-blue-left text-white my-2 fw-bold corner-rounded py-10 px-10 w-100 shadow-sm"
                      >
                        <span className="text-uppercase">{t("2929", "Find a Report").toUpperCase()}</span>
                      </Link>
                    </div>
                    <div className="col-md-4 col-sm-6 col-12">
                      <Link
                        to="/portal/documents/create"
                        className="d-block text-center btn-menu-light-blue-left btn-menu-dark-blue-color my-2 fw-bold corner-rounded py-10 px-10 w-100 shadow-sm"
                      >
                        <span className="text-uppercase">
                          {t("622", "UPLOAD DOCUMENTS").toUpperCase()}
                        </span>
                      </Link>
                    </div>
                  </div>
                  <div className="row">
                    <div className="pt-3 px-4">
                      <i class="fa-solid fa-star text-primary me-2 "></i>
                      <span
                        className="pvs-title fw-bold fs-2 lh-1"
                      >
                        {t("-1", "Data and Insights")}
                      </span>
                    </div>
                    <div className="col-md-4 col-sm-6 col-12">
                      <Link
                        to="/portal/qualitative-dashboards"
                        className="d-block text-center btn-menu-dark-green-left text-white my-2 fw-bold corner-rounded py-10 px-10 w-100 shadow-sm"
                      >
                        <span className="text-uppercase">
                          {t("2896", "View PVS Insights").toUpperCase()}
                        </span>
                      </Link>
                    </div>
                    <div className="col-md-4 col-sm-6 col-12">
                      <Link
                        to="/portal/insights"
                        className="d-block text-center btn-menu-medium-green-left btn-menu-dark-green-color my-2 fw-bold corner-rounded py-10 px-10 w-100 shadow-sm"
                      >
                        <span className="text-uppercase">
                          {t(
                            "2930",
                            "Explore Critical Competencies"
                          ).toUpperCase()}
                        </span>
                      </Link>
                    </div>
                    <div className="col-md-4 col-sm-6 col-12">
                      <TaskAccessComponent
                        requestRelloader={requestRelloader}
                        title={t("948", "REQUEST A REPORT").toUpperCase()}
                        isReport={true}
                        className="d-block text-center btn-menu-light-green-left btn-menu-dark-green-color fw-bold corner-rounded py-10 px-10 w-100 shadow-sm text-uppercase"
                      />
                    </div>
                  </div>
                </>
              )
              }
              {USER_ROLES.super_administrator.includes(
                parseInt(authData.role_id)
              ) && (
                  <>
                    <div className="col-md-3 col-sm-6 col-12">
                      <Link
                        to="/portal/mission-management"
                        className="d-block text-center btn-menu-medium-orange-left btn-menu-dark-orange-color my-2 fw-bold corner-rounded py-10 px-10 w-100 shadow-sm"
                      >
                        <span className="text-uppercase">
                          {t("2885", "MANAGE MY MISSIONS").toUpperCase()}
                        </span>
                      </Link>
                    </div>
                    <div className="col-md-3 col-sm-6 col-12">
                      <Link
                        to="/portal/mission-management/create"
                        className="d-block text-center btn-menu-dark-orange-left my-2 corner-rounded text-white fw-bold py-10 px-10 w-100 shadow-sm"
                      >
                        <span className="text-uppercase">
                          {t("262", "ADD NEW MISSION").toUpperCase()}
                        </span>
                      </Link>
                    </div>
                    <div className="col-md-3 col-sm-6 col-12">
                      <Link
                        to="/portal/documents/create"
                        className="d-block text-center btn-menu-light-blue-left  btn-menu-dark-blue-color my-2 fw-bold corner-rounded py-10 px-10 w-100 shadow-sm"
                      >
                        <span className="text-uppercase">
                          {t("622", "UPLOAD DOCUMENTS").toUpperCase()}
                        </span>
                      </Link>
                    </div>
                  </>
                )}
              {USER_ROLES.it_admin.includes(parseInt(authData.role_id)) && (
                <>
                  <div className="pt-3 px-4">
                    <i class="fa-solid fa-star text-primary me-2 "></i>
                    <span
                      className="pvs-title fw-bold fs-2 lh-1"
                    >
                      {t("-1", "Missions")}
                    </span>
                  </div>
                  <div className="col-md-4 col-sm-6 col-12">
                    <Link
                      // onClick={(e) => {
                      //   if (enviornmentRestrict("PROD")) {
                      //     e.preventDefault();
                      //     setShowNewFeature(true);
                      //   }
                      // }}
                      to="/portal/mission-cc"
                      className="d-block text-center btn-menu-dark-orange-left text-white my-2 fw-bold corner-rounded py-10 px-10 w-100 shadow-sm"
                    >
                      <span className="text-uppercase">{t("-1", "Mission Control Center").toUpperCase()}</span>
                    </Link>
                  </div>
                  <div className="row">
                    <div className="pt-3 px-4">
                      <i class="fa-solid fa-star text-primary me-2 "></i>
                      <span
                        className="pvs-title fw-bold fs-2 lh-1"
                      >
                        {t("-1", "Reports")}
                      </span>
                    </div>
                    <div className="col-md-4 col-sm-6 col-12">
                      <Link
                        to="/portal/documents"
                        className="d-block text-center btn-menu-dark-blue-left text-white my-2 fw-bold corner-rounded py-10 px-10 w-100 shadow-sm"
                      >
                        <span className="text-uppercase">{t("2929", "Find a Report").toUpperCase()} </span>
                      </Link>
                    </div>
                    <div className="col-md-4 col-sm-6 col-12">
                      <TaskAccessComponent
                        requestRelloader={requestRelloader}
                        title={t("948", "REQUEST A REPORT").toUpperCase()}
                        isReport={true}
                        className="d-block text-center btn-menu-medium-blue-left btn-menu-dark-blue-color  fw-bold corner-rounded py-10 px-10 w-100 shadow-sm text-uppercase"
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="pt-3 px-4">
                      <i class="fa-solid fa-star text-primary me-2 "></i>
                      <span
                        className="pvs-title fw-bold fs-2 lh-1"
                      >
                        {t("-1", "Data and Insights")}
                      </span>
                    </div>
                    <div className="col-md-4 col-sm-6 col-12">
                      <Link
                        to="/portal/qualitative-dashboards"
                        className="d-block text-center btn-menu-dark-green-left text-white my-2 fw-bold corner-rounded py-10 px-10 w-100 shadow-sm"
                      >
                        <span className="text-uppercase">{t("2896", "View PVS Insights").toUpperCase()}</span>
                      </Link>
                    </div>
                    <div className="col-md-4 col-sm-6 col-12">
                      <Link
                        to="/portal/insights"
                        className="d-block text-center btn-menu-medium-green-left btn-menu-dark-green-color my-2 fw-bold corner-rounded py-10 px-10 w-100 shadow-sm"
                      >
                        <span className="text-uppercase">{t("2930", "Explore Critical Competencies").toUpperCase()}</span>
                      </Link>
                    </div>
                    <div className="col-md-4 col-sm-6 col-12">
                      <Link
                        to="/portal/indicator/index"
                        className="d-block text-center btn-menu-light-green-left btn-menu-dark-green-color  my-2 fw-bold corner-rounded py-10 px-10 w-100 shadow-sm"

                      >
                        <span className="text-uppercase">{t("-1", "Request an indicator").toUpperCase()}</span>
                      </Link>
                    </div>
                  </div>
                  <div className="row">
                    <div className="pt-3 px-4">
                      <i class="fa-solid fa-star text-primary me-2 "></i>
                      <span
                        className="pvs-title fw-bold fs-2 lh-1"
                      >
                        {t("-1", "Partners")}
                      </span>
                    </div>
                    <div className="col-md-4 col-sm-6 col-12">
                      <Link
                        to="/portal/partner-tech/index"
                        className="d-block text-center btn-menu-medium-green-left btn-menu-dark-green-color my-2 fw-bold corner-rounded py-10 px-10 w-100 shadow-sm"
                      >
                        <span className="text-uppercase">{t("-1", "MANAGE Technical Partners").toUpperCase()}</span>
                      </Link>
                    </div>
                  </div>
                </>
              )}

              {(USER_ROLES.woah_staff_without_cbd_and_rr_srr.includes(parseInt(authData.role_id)) ||
                USER_ROLES.rr_srr.includes(parseInt(authData.role_id))) && (
                  <>
                    <div className="row">
                      <div className="pt-3 px-4">
                        <i class="fa-solid fa-star text-primary me-2 "></i>
                        <span
                          className="pvs-title fw-bold fs-2 lh-1"
                        >
                          {t("-1", "Missions")}
                        </span>
                      </div>
                      <div className="col-md-4 col-sm-6 col-12">
                        <Link
                          to="/portal/mission-management/?return=/portal"
                          className="d-block text-center btn-menu-dark-orange-left my-4 text-white fw-bold corner-rounded py-10 px-10 w-100 shadow-sm"
                        >
                          <span className="text-uppercase">{t("-1", "SEARCH MISSIONS").toUpperCase()}</span>
                        </Link>
                      </div>
                      {authData.has_active_mission && (
                        <>
                          <div className="col-md-4 col-12">
                            <Link
                              // onClick={(e) => {
                              //   if (enviornmentRestrict("PROD")) {
                              //     e.preventDefault();
                              //     setShowNewFeature(true);
                              //   }
                              // }}
                              to="/portal/mission-cc"
                              className="d-block text-center btn-menu-dark-orange-left text-white my-4 fw-bold corner-rounded py-10 px-10 w-100 shadow-sm"
                            >
                              <span>{t("-1", "Mission Control Center").toUpperCase()}</span>
                            </Link>
                          </div>
                        </>
                      )
                      }
                      {USER_ROLES.rr_woah_staff.includes(parseInt(authData.role_id)) &&
                        <div className="col-md-4 col-sm-6 col-12">
                          <Link
                            to="/portal/request-mission"
                            className="d-block text-center btn-menu-light-orange-left btn-menu-dark-orange-color my-4 corner-rounded fw-bold py-10 px-10 w-100 shadow-sm"
                          >
                            <span className="text-uppercase">{t("626", "REQUEST A MISSION").toUpperCase()}</span>
                          </Link>

                        </div>
                      }
                    </div>
                    <div className="row">
                      <div className="pt-3 px-4">
                        <i class="fa-solid fa-star text-primary me-2 "></i>
                        <span
                          className="pvs-title fw-bold fs-2 lh-1"
                        >
                          {t("-1", "Reports")}
                        </span>
                      </div>
                      <div className="col-md-4 col-sm-6 col-12">
                        <Link
                          to="/portal/documents"
                          className="d-block text-center btn-menu-dark-blue-left text-white my-4 fw-bold corner-rounded py-10 px-10 w-100 shadow-sm"
                        >
                          <span className="text-uppercase">{t("2929", "Find a Report").toUpperCase()}</span>
                        </Link>
                      </div>
                      <div className="col-md-4 col-sm-6 col-12">
                        <TaskAccessComponent
                          requestRelloader={requestRelloader}
                          title={t("948", "REQUEST A REPORT").toUpperCase()}
                          isReport={true}
                          className="d-block text-center btn-menu-medium-blue-left btn-menu-dark-blue-color my-2 fw-bold corner-rounded py-10 px-10 w-100 shadow-sm"
                        >
                        </TaskAccessComponent>
                      </div>
                      {USER_ROLES.rr_srr.includes(parseInt(authData.role_id)) &&
                        <div className="col-md-4 col-sm-6 col-12">
                          <Link
                            to="/portal/documents"
                            className="d-block text-center btn-menu-light-blue-left btn-menu-dark-blue-color my-4 fw-bold corner-rounded py-10 px-10 w-100 shadow-sm"
                          >
                            <span>{t("2897", "VIEW REPORTS").toUpperCase()}</span>
                          </Link>
                        </div>
                      }
                    </div>
                    <div className="row">
                      <div className="pt-3 px-4">
                        <i class="fa-solid fa-star text-primary me-2 "></i>
                        <span
                          className="pvs-title fw-bold fs-2 lh-1"
                        >
                          {t("-1", "Data and Insights")}
                        </span>
                      </div>
                      <div className="col-md-4 col-sm-6 col-12">
                        <Link
                          to="/portal/qualitative-dashboards"
                          className="d-block text-center btn-menu-dark-green-left text-white my-2 fw-bold corner-rounded py-10 px-10 w-100 shadow-sm"
                        >
                          <span className="text-uppercase">{t("2896", "View PVS Insights").toUpperCase()}</span>
                        </Link>
                      </div>
                      <div className="col-md-4 col-sm-6 col-12">
                        <Link
                          to="/portal/insights"
                          className="d-block text-center btn-menu-medium-green-left btn-menu-dark-green-color my-2 fw-bold corner-rounded py-10 px-10 w-100 shadow-sm"
                        >
                          <span className="text-uppercase">{t("2930", "Explore Critical Competencies").toUpperCase()}</span>
                        </Link>
                      </div>
                      {
                        !USER_ROLES.rr_srr.includes(parseInt(authData.role_id)) &&
                        <div className="col-md-4 col-sm-6 col-12">
                          <Link
                            to="/portal/indicator/index"
                            className="d-block text-center btn-menu-light-green-left btn-menu-dark-green-color  my-2 fw-bold corner-rounded py-10 px-10 w-100 shadow-sm"
                          >
                            <span className="text-uppercase">{t("-1", "Request an indicator").toUpperCase()}</span>
                          </Link>
                        </div>
                      }
                    </div>
                  </>
                )}
              {(USER_ROLES.technical_partner.includes(parseInt(authData.role_id))) && (
                <>
                  <div className="col-md-4 col-sm-6 col-12">
                    <Link
                      to="/portal/mission-management/?return=/portal"
                      className="d-block text-center btn-menu-dark-orange-left my-4 text-white fw-bold corner-rounded py-10 px-10 w-100 shadow-sm"
                    >
                      <span className="text-uppercase">{t("-1", "SEARCH MISSIONS").toUpperCase()}</span>
                    </Link>
                  </div>
                  {USER_ROLES.rr_woah_staff.includes(parseInt(authData.role_id)) &&
                    <div className="col-md-4 col-sm-6 col-12">
                      <Link
                        to="/portal/request-mission"
                        className="d-block text-center btn-menu-light-orange-left btn-menu-dark-orange-color my-4 corner-rounded fw-bold py-10 px-10 w-100 shadow-sm"
                      >
                        <span className="text-uppercase">{t("626", "REQUEST A MISSION").toUpperCase()}</span>
                      </Link>

                    </div>
                  }
                  <div className="row">
                    <div className="pt-3 px-4">
                      <i class="fa-solid fa-star text-primary me-2 "></i>
                      <span
                        className="pvs-title fw-bold fs-2 lh-1"
                      >
                        {t("-1", "Reports")}
                      </span>
                    </div>
                    <div className="col-md-4 col-sm-6 col-12">
                      <Link
                        to="/portal/documents"
                        className="d-block text-center btn-menu-light-blue-left btn-menu-dark-blue-color my-4 fw-bold corner-rounded py-10 px-10 w-100 shadow-sm"
                      >
                        <span>{t("2897", "VIEW REPORTS").toUpperCase()}</span>
                      </Link>
                    </div>

                    <div className="col-md-4 col-sm-6 col-12">
                      <Link
                        to="/portal/documents"
                        className="d-block text-center btn-menu-dark-blue-left text-white my-4 fw-bold corner-rounded py-10 px-10 w-100 shadow-sm"
                      >
                        <span className="text-uppercase">{t("2929", "Find a Report").toUpperCase()}</span>
                      </Link>
                    </div>
                    <div className="col-md-4 col-sm-6 col-12">
                      <TaskAccessComponent
                        requestRelloader={requestRelloader}
                        title={t("948", "REQUEST A REPORT").toUpperCase()}
                        isReport={true}
                        className="d-block text-center btn-menu-medium-blue-left btn-menu-dark-blue-color my-2 fw-bold corner-rounded py-10 px-10 w-100 shadow-sm"
                      >
                      </TaskAccessComponent>
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-6 col-12">
                    <Link
                      to="/portal/qualitative-dashboards"
                      className="d-block text-center btn-menu-dark-green-left text-white my-2 fw-bold corner-rounded py-10 px-10 w-100 shadow-sm"
                    >
                      <span className="text-uppercase">{t("2896", "View PVS Insights").toUpperCase()}</span>
                    </Link>
                  </div>
                  <div className="col-md-4 col-sm-6 col-12">
                    <Link
                      to="/portal/insights"
                      className="d-block text-center btn-menu-medium-green-left btn-menu-dark-green-color my-2 fw-bold corner-rounded py-10 px-10 w-100 shadow-sm"
                    >
                      <span className="text-uppercase">{t("2930", "Explore Critical Competencies").toUpperCase()}</span>
                    </Link>
                  </div>
                </>
              )}

              {USER_ROLES.delegate_roles_group.includes(parseInt(authData.role_id)) && (
                <>
                  <div className="mb-4">
                    <div className="mb-2 align-item-center">
                      <i class="fa-solid fa-star text-primary me-2 "></i>
                      <span
                        className="pvs-title fw-bold fs-2 lh-1"
                      >
                        {t("-1", "Missions")}
                      </span>
                    </div>
                    <div className="row">
                      {
                        (authData.has_mission && !USER_ROLES.delegate_roles_group.includes(parseInt(authData.role_id))) && (
                          <div className="col-md-4 col-sm-6 col-12">
                            <Link
                              to="#"
                              onClick={handleClickScroll}
                              className="d-block text-center btn-menu-medium-orange-left btn-menu-dark-orange-color my-2  fw-bold corner-rounded py-10 px-10 w-100 shadow-sm"
                            >
                              <span>{t("2885", "MANAGE MY MISSIONS").toUpperCase()}</span>
                            </Link>
                          </div>
                        )
                      }
                      {loadingUserMissionStatus ? (
                        <div className="col-md-4 col-12">
                          <Skeleton variant="rounded" width={"100%"} height={80} className="corner-rounded" sx={{ my: 1 }} />
                        </div>
                      ) : (
                        userMissionStatus?.has_mission &&
                        userMissionStatus?.has_active_mission && (
                          <div className="col-md-4 col-12">
                            <Link
                              // onClick={(e) => {
                              //   if (enviornmentRestrict("PROD")) {
                              //     e.preventDefault();
                              //     setShowNewFeature(true);
                              //   }
                              // }}
                              to="/portal/mission-cc"
                              className="d-block text-center btn-menu-dark-orange-left text-white my-2 fw-bold corner-rounded py-10 px-10 w-100 shadow-sm"
                            >
                              <span>{t("-1", "Mission Control Center").toUpperCase()}</span>
                            </Link>
                          </div>
                        )
                      )}
                      <div className="col-md-4 col-sm-6 col-12">
                        <Link
                          // onClick={(e) => {
                          //   if (enviornmentRestrict("PROD")) {
                          //     e.preventDefault();
                          //     setShowNewFeature(true);
                          //   }
                          // }}
                          to="/portal/mission-request"
                          className="d-block text-center btn-menu-light-orange-left btn-menu-dark-orange-color my-2 fw-bold corner-rounded py-10 px-10 w-100 shadow-sm"
                        >
                          <span>{t("626", "REQUEST A MISSION").toUpperCase()}</span>
                        </Link>
                      </div>
                    </div>
                  </div>

                  <div className="mb-4">
                    <div className="mb-2 align-item-center">
                      <i class="fa-solid fa-star text-primary me-2 "></i>
                      <span
                        className="pvs-title fw-bold fs-2 lh-1"
                      >
                        {t("-1", "Reports and Documents")}
                      </span>
                    </div>
                    <div className="row">
                      <div className="col-md-4 col-sm-6 col-12">
                        <Link
                          to="/portal/documents"
                          className="d-block text-center btn-menu-dark-blue-left text-white my-2 fw-bold corner-rounded py-10 px-10 w-100 shadow-sm"
                        >
                          <span className="text-uppercase">{t("2929", "Find a Report").toUpperCase()}</span>
                        </Link>
                      </div>
                      <div className="col-md-4 col-sm-6 col-12">
                        <TaskAccessComponent
                          requestRelloader={requestRelloader}
                          title={t("948", "REQUEST A REPORT").toUpperCase()}
                          isReport={true}
                          className="d-block text-center btn-menu-medium-blue-left btn-menu-dark-blue-color fw-bold corner-rounded py-10 px-10 w-100 shadow-sm"
                        />
                      </div>
                      {
                        authData.has_mission && (
                          <div className="col-md-4 col-sm-6 col-12">
                            <Link
                              to="/portal/documents/create"
                              className="d-block text-center btn-menu-light-blue-left btn-menu-dark-blue-color my-2 fw-bold corner-rounded py-10 px-10 w-100 shadow-sm"
                            >
                              <span>{t("622", "UPLOAD DOCUMENTS").toUpperCase()}</span>
                            </Link>
                          </div>
                        )
                      }
                    </div>
                  </div>
                  <div className="mb-4">
                    <div className="mb-2 align-item-center">
                      <i class="fa-solid fa-star text-primary me-2 "></i>
                      <span
                        className="pvs-title fw-bold fs-2 lh-1"
                      >
                        {t("-1", "Data and Insights")}
                      </span>
                    </div>
                    <div className="row">
                      <div className="col-md-4 col-sm-6 col-12">
                        <Link
                          to="/portal/qualitative-dashboards"
                          className="d-block text-center btn-menu-dark-green-left text-white my-2 fw-bold corner-rounded py-10 px-10 w-100 shadow-sm"
                        >
                          <span className="text-uppercase">{t("2896", "View PVS Insights").toUpperCase()}</span>
                        </Link>
                      </div>
                      <div className="col-md-4 col-sm-6 col-12">
                        <Link
                          to="/portal/insights"
                          className="d-block text-center btn-menu-medium-green-left btn-menu-dark-green-color my-2  fw-bold corner-rounded py-10 px-10 w-100 shadow-sm"
                        >
                          <span className="text-uppercase">
                            {t("2930", "Explore Critical Competencies").toUpperCase()}
                          </span>
                        </Link>
                      </div>
                      <div className="col-md-4 col-sm-6 col-12">
                        <Link
                          to="/portal/indicator/index"
                          className="d-block text-center btn-menu-light-green-left btn-menu-dark-green-color my-2 fw-bold corner-rounded py-10 px-10 w-100 shadow-sm"
                        >
                          <span className="text-uppercase">{t("-1", "Request an indicator").toUpperCase()}</span>
                        </Link>
                      </div>
                    </div>
                  </div>
                  {USER_ROLES.delegate_roles_group.includes(parseInt(authData?.role_id)) &&
                    <div className="mb-4">
                      <div className="mb-2 align-item-center">
                        <i class="fa-solid fa-star text-primary me-2 "></i>
                        <span
                          className="pvs-title fw-bold fs-2 lh-1"
                        >
                          {t("-1", "Others")}
                        </span>
                      </div>
                      <div className="row">
                        <div className="col-md-4 col-sm-6 col-12">
                          <Link
                            to="/portal/designate-user-management"
                            className="d-block text-center btn-menu-dark-black-left my-2 text-white fw-bold corner-rounded py-10 px-10 w-100 shadow-sm"
                          >
                            <span>{t("-1", "Designate Additional Account Holder").toUpperCase()}</span>
                          </Link>
                        </div>
                      </div>
                    </div>
                  }
                </>
              )}
              {USER_ROLES.experts.includes(parseInt(authData.role_id)) && (
                <>
                  {
                    authData.has_active_mission && (
                      <>
                        <div className="row">
                          <div className="mb-2 align-item-center">
                            <i class="fa-solid fa-star text-primary me-2 "></i>
                            <span
                              className="pvs-title fw-bold fs-2 lh-1"
                            >
                              {t("-1", "Missions")}
                            </span>
                          </div>
                          <div className="col-md-4 col-sm-6 col-12">
                            <Link
                              // onClick={(e) => {
                              //   if (enviornmentRestrict("PROD")) {
                              //     e.preventDefault();
                              //     setShowNewFeature(true);
                              //   }
                              // }}
                              to="/portal/mission-cc"
                              className="d-block text-center btn-menu-dark-orange-left text-white my-2 fw-bold corner-rounded py-10 px-10 w-100 shadow-sm"
                            >
                              <span>{t("-1", "Mission Control Center").toUpperCase()}</span>
                            </Link>
                          </div>
                        </div>

                      </>

                    )
                  }
                  <div className="row">
                    <div className="mb-2 align-item-center">
                      <i class="fa-solid fa-star text-primary me-2 "></i>
                      <span
                        className="pvs-title fw-bold fs-2 lh-1"
                      >
                        {t("-1", "Reports")}
                      </span>
                    </div>
                    <div className="col-md-4 col-sm-6 col-12">
                      <TaskAccessComponent
                        requestRelloader={requestRelloader}
                        title={t("948", "REQUEST A REPORT").toUpperCase()}
                        isReport={true}
                        className="d-block text-center btn-menu-medium-blue-left btn-menu-dark-blue-color fw-bold corner-rounded py-10 px-10 w-100 shadow-sm text-uppercase"
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="mb-2 align-item-center">
                      <i class="fa-solid fa-star text-primary me-2 "></i>
                      <span
                        className="pvs-title fw-bold fs-2 lh-1"
                      >
                        {t("-1", "Indicator")}
                      </span>
                    </div>
                    <div className="col-md-4 col-sm-6 col-12">
                      <Link
                        to="/portal/indicator/index"
                        className="d-block text-center btn-menu-light-green-left btn-menu-dark-green-color  my-2 corner-rounded fw-bold py-10 px-10 w-100 shadow-sm"
                      >
                        <span className="text-uppercase">{t("-1", "Request an indicator").toUpperCase()}</span>
                      </Link>
                    </div>
                  </div>



                </>
              )}
              {USER_ROLES.partners_and_donors.includes(parseInt(authData.role_id)) && (
                <>
                  <div className="row">
                    <div className="pt-3 px-4">
                      <i class="fa-solid fa-star text-primary me-2 "></i>
                      <span
                        className="pvs-title fw-bold fs-2 lh-1"
                      >
                        {t("-1", "Reports")}
                      </span>
                    </div>
                    <div className="col-md-4 col-sm-6 col-12">
                      <Link
                        to="/portal/documents"
                        className="d-block text-center btn-menu-dark-blue-left text-white my-2 fw-bold corner-rounded py-10 px-10 w-100 shadow-sm"
                      >
                        <span className="text-uppercase">{t("2929", "Find a Report").toUpperCase()}</span>
                      </Link>
                    </div>
                    <div className="col-md-4  col-12">
                      <TaskAccessComponent
                        requestRelloader={requestRelloader}
                        title={t("948", "REQUEST A REPORT").toUpperCase()}
                        isReport={true}
                        className="d-block text-center btn-menu-medium-blue-left btn-menu-dark-blue-color fw-bold corner-rounded py-10 px-10 w-100 shadow-sm text-uppercase"
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="pt-3 px-4">
                      <i class="fa-solid fa-star text-primary me-2 "></i>
                      <span
                        className="pvs-title fw-bold fs-2 lh-1"
                      >
                        {t("-1", "Data and Insights")}
                      </span>
                    </div>
                    <div className="col-md-4 col-sm-6 col-12">
                      <Link
                        to="/portal/qualitative-dashboards"
                        className="d-block text-center btn-menu-dark-green-left text-white my-2 fw-bold corner-rounded py-10 px-10 w-100 shadow-sm"
                      >
                        <span className="text-uppercase">{t("2896", "View PVS Insights").toUpperCase()}</span>
                      </Link>
                    </div>
                    <div className="col-md-4 col-sm-6 col-12">
                      <Link
                        to="/portal/insights"
                        className="d-block text-center btn-menu-medium-green-left btn-menu-dark-green-color my-2 fw-bold corner-rounded py-10 px-10 w-100 shadow-sm"
                      >
                        <span className="text-uppercase">{t("2930", "Explore Critical Competencies").toUpperCase()}</span>
                      </Link>
                    </div>
                    <div className="row">
                      <div className="pt-3 px-4">
                        <i class="fa-solid fa-star text-primary me-2 "></i>
                        <span
                          className="pvs-title fw-bold fs-2 lh-1"
                        >
                          {t("-1", "Data and Insights")}
                        </span>
                      </div>
                      <div className="col-md-4 col-sm-6 col-12">
                        <Link
                          to="/portal/qualitative-dashboards"
                          className="d-block text-center btn-menu-dark-green-left text-white my-2 fw-bold corner-rounded py-10 px-10 w-100 shadow-sm"
                        >
                          <span className="text-uppercase">{t("2896", "View PVS Insights").toUpperCase()}</span>
                        </Link>
                      </div>
                      <div className="col-md-4 col-sm-6 col-12">
                        <Link
                          to="/portal/insights"
                          className="d-block text-center btn-menu-medium-green-left btn-menu-dark-green-color my-2 fw-bold corner-rounded py-10 px-10 w-100 shadow-sm"
                        >
                          <span className="text-uppercase">{t("2930", "Explore Critical Competencies").toUpperCase()}</span>
                        </Link>
                      </div>

                      <div className="col-md-4 col-sm-6 col-12">
                        <Link
                          to="/portal/indicator/index"
                          className="d-block text-center btn-menu-light-green-left btn-menu-dark-green-color  my-2 fw-bold corner-rounded py-10 px-10 w-100 shadow-sm"
                        >
                          <span className="text-uppercase">{t("-1", "Request an indicator").toUpperCase()}</span>
                        </Link>
                      </div>
                    </div>
                  </div>
                </>
              )}

            </div>
          </div>
        </div>
      </div>
    </>
  );
};

TaskCard.defaultProps = {
  requestRelloader: null,
};

export default TaskCard;
